import Lesson from './Lesson';
import { Model, Nullable, Ordenable } from './Model';
import ScheduledLessonPlanItem from './ScheduledLessonPlanItem';
import { ContentGivenEnum } from './ScheduledLessonReport';
import Unit from './Unit';

export enum ScheduledLessonTypeEnum {
  NORMAL = 'NORMAL',
  EXTRA = 'EXTRA',
  FREE = 'FREE',
}

export type LessonBlockRef = Pick<Unit, 'id' | 'name' | 'order'>;

export type ScheduledLessonNestedLesson = Lesson & {
  lessonBlock?: Nullable<LessonBlockRef>;
};

export default interface ScheduledLesson extends Model, Ordenable {
  klass: number;
  lesson: Nullable<ScheduledLessonNestedLesson>;
  datetime: string;
  notes: string;
  teacher: number;
  hasDone: boolean;
  url?: string;
  progress: number;
  isActive: boolean;
  givenContent?: ContentGivenEnum;
  presences: number;
  absences: number;
  homeworkActivity: number | null;
  hasHomeworkActivity: boolean;
  type: ScheduledLessonTypeEnum;
  resources: Array<number>;
  assignmentStatus: AssignmentStatusEnum;
  scheduledLessonPlanItems: Array<ScheduledLessonPlanItem>;
}

export enum AssignmentStatusEnum {
  ASSIGNED = 'ASSIGNED',
  PENDING_ASSIGNMENT = 'PENDING_ASSIGNMENT',
}

export enum RescheduleTypeEnum {
  POSTPONE = 'POSTPONE',
  ANTICIPATE = 'ANTICIPATE',
}

export enum LessonTimeframeEnum {
  ALL = 'ALL',
  ONGOING = 'ONGOING',
  PAST = 'PAST',
  UPCOMING = 'UPCOMING',
}
